module.exports = __webpack_public_path__ + "42a9a4e0c7d560aa678f90e4b696db41.ttf";